import React, {useState} from "react";
import {Button, CircularProgress, Stack, Tab, Tabs, Tooltip, Typography} from "@mui/material";
import {HugeiconsIcon} from '@hugeicons/react';
import {Add01Icon, Refresh01Icon} from '@hugeicons/core-free-icons';
import {VocabularyTabContent} from "./components/VocabularyTabContent";
import {PhonemizeCreateModal} from "./components/PhonemizeCreateModal";
import {VocabularyRepository} from "../../../repositories/VocabularyRepository";
import {toast} from "react-toastify";

export const VocabularyPage = ({project}) => {
  const [activeTab, setActiveTab] = useState("PRONUNCIATION");
  const [phonemizerModalOpen, setPhonemizeModalOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [reloadingPhonemizer, setReloadingPhonemizer] = useState(false);

  const handleReloadPhonemizer = async () => {
    setReloadingPhonemizer(true);
    try {
      await VocabularyRepository.reloadPhonemizer(project?.id);
      toast.success("Phonemizer reloaded successfully");
    } catch (error) {
      console.error(error);
      toast.error("Failed to reload Phonemizer");
    } finally {
      setReloadingPhonemizer(false);
    }
  };

  return (
    <Stack direction="column" maxWidth="xl" gap={2}
           sx={{p: 3, width: "90%", mx: "auto", maxHeight: "calc(100dvh - 80px)"}}>
      <Typography variant="h4" fontWeight={600}>Vocabulary</Typography>

      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Tabs
          value={activeTab}
          onChange={(_, val) => setActiveTab(val)}
          textColor="inherit"
          indicatorColor="primary"
        >
          <Tab label="Pronunciation" value="PRONUNCIATION"/>
          <Tab label="Phonemizer" value="PHONEMIZER"/>
        </Tabs>

        {activeTab === "PHONEMIZER" && (
          <Stack direction="row" gap={1}>
            <Button
              size="small"
              variant="modal"
              color="secondary"
              onClick={() => setPhonemizeModalOpen(true)}
              startIcon={<HugeiconsIcon icon={Add01Icon} size={18}/>}
              disabled={!project?.id}
            >
              Create
            </Button>
            <Tooltip title="Reload Phonemizer" arrow placement="top">
              <Button
                size="small"
                variant="modal"
                color="secondary"
                onClick={handleReloadPhonemizer}
                startIcon={reloadingPhonemizer ? <CircularProgress size={16} color="inherit"/> : <HugeiconsIcon icon={Refresh01Icon} size={20}/>}
                disabled={!project?.id || reloadingPhonemizer}
              >
                Reload Phonemizer
              </Button>
            </Tooltip>
          </Stack>
        )}
      </Stack>

      <VocabularyTabContent
        key={`${activeTab}-${refreshKey}`}
        project={project}
        vocabularyType={activeTab}
      />

      <PhonemizeCreateModal
        open={phonemizerModalOpen}
        onClose={() => setPhonemizeModalOpen(false)}
        onSuccess={() => setRefreshKey(k => k + 1)}
        projectId={project?.id}
      />
    </Stack>
  );
};
